import React, { useState } from 'react';

import { Segmented } from 'antd';

import NwDrawer from '@components/Gui/NwDrawer';
import ExpenseFormNonBookingEvent from '@components/Transactions/TransactionsCreateForms/ExpenseFormNonBookingEvent';
import RefundFormNonBookingEvent from '@components/Transactions/TransactionsCreateForms/RefundFormNonBookingEvent';

import { TransactionDrawerContent } from '../../Project/ProjectTransactions/Transactions/ProjectTransactionsUI';

const AddNonBookingEventTransactionDrawer = ({ event, eventType, onClose, onSave, periodGroup = false }) => {
    const [touchForm, setTouchForm] = useState(false);
    const [selectedTab, setSelectedTab] = useState(1);

    return (
        <NwDrawer
            width="60vw"
            minWidth="980px"
            touchForm={touchForm}
            onTouchForm={setTouchForm}
            onClose={onClose}
            title={`New Expense`}
        >
            <TransactionDrawerContent>
                <Segmented
                    block
                    value={selectedTab}
                    onChange={setSelectedTab}
                    options={[
                        {
                            label: (
                                <div>
                                    <h2>Expense</h2>
                                    <small>paid by the agency for the model</small>
                                </div>
                            ),
                            value: 1,
                        },
                        {
                            label: (
                                <div>
                                    <h2>Refund</h2>
                                    <small>expense paid by the model</small>
                                </div>
                            ),
                            value: 2,
                        },
                    ]}
                />
                {selectedTab === 1 && (
                    <ExpenseFormNonBookingEvent
                        event={event}
                        onCloseDrawer={onClose}
                        onSave={onSave}
                        eventType={eventType}
                        periodGroup={periodGroup}
                    />
                )}
                {selectedTab === 2 && (
                    <RefundFormNonBookingEvent
                        event={event}
                        onCloseDrawer={onClose}
                        onSave={onSave}
                        eventType={eventType}
                        periodGroup={periodGroup}
                    />
                )}
            </TransactionDrawerContent>
        </NwDrawer>
    );
};

export default AddNonBookingEventTransactionDrawer;
